// Extract Vimeo video ID from URL
export function extractVimeoId(url: string): string | null {
  const regex = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
  const match = url.match(regex);
  return match ? match[3] : null;
}

// Fetch video metadata from Vimeo oEmbed API
export async function fetchVimeoMetadata(url: string) {
  try {
    const response = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`);
    if (!response.ok) {
      throw new Error('Failed to fetch video metadata');
    }
    const data = await response.json();

    // Extract video ID from the URL since oEmbed doesn't provide it
    const videoId = extractVimeoId(url);

    console.log(data);

    return {
      videoId: videoId,
      title: data.title,
      description: data.description || '', // May not always be provided
      duration: data.duration, // Note: oEmbed doesn't reliably provide duration
      thumbnailUrl: data.thumbnail_url,
      authorName: data.author_name,
    };
  } catch (error) {
    console.error('Error fetching Vimeo metadata:', error);
    return null;
  }
}
